import { types } from 'mobx-state-tree';


const MARITAL_STATUSES = {
    MARRIED: 'married',
    SINGLE: 'single',
    COMMON_LAW: 'common-law',
    SEPARATED: 'separated',
    DIVORCED: 'divorced',
    WIDOWED: 'widowed',
    OTHER: 'other',
};

const MaritalStatusEnum = types.enumeration('MaritalStatus', Object.values(MARITAL_STATUSES));

export {
    MaritalStatusEnum,
};
export default MARITAL_STATUSES;
